import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateService} from "../../services/translate.service";
import {SchoolProgramModel} from "../../models/school-program-model";
import {SchoolProgramService} from "../../services/school-program.service";
import {SchoolProgramCategoryModel} from "../../models/school-program-category-model";
import { SettingService } from 'src/shared/services/setting.service';

@Component({
  selector: 'app-select-school-program-category',
  templateUrl: './select-school-program-category.component.html',
  styleUrls: ['./select-school-program-category.component.css']
})
export class SelectSchoolProgramCategoryComponent implements OnInit, OnChanges, OnDestroy {

  heading = 'School program category select';
  loading: boolean;
  schoolprogramcategoryValue: SchoolProgramCategoryModel;
  schoolCategoryList: SchoolProgramCategoryModel[] = [];
  localStorageName = 'client.spcdata';

  @Output()
  schoolProgramCategoryChanged = new EventEmitter<SchoolProgramCategoryModel>();

  @Input()
  isDisabled = false;

  @Input()
  school_program_id = null;

  @Input()
  usingLocalStorage = true;

  @Input()
  all = false;
  schoolProgramCategoryData :any = [];
  private categorySub: Subscription | null = null;
  private loadedByChanges = false;
  constructor(
    private translate: TranslateService,
    private schoolProgramService: SchoolProgramService,
    private setting: SettingService
  ) {
  }

  ngOnInit() {
    this.translate.load('extracurricular');
    // ngOnChanges already fetched with the bound inputs; don't hit again with an empty payload.
    if (!this.loadedByChanges) this.getSchoolProgramCategories();
  }

  ngOnDestroy(): void {
    this.categorySub?.unsubscribe();
  }

  ngOnChanges(changes: any): void {
    this.schoolprogramcategoryValue = null;
    this.loadedByChanges = true;
    if (this.school_program_id) {
      this.getSchoolProgramCategories();
    } else {
      this.categorySub?.unsubscribe();
      this.schoolProgramCategoryData = [];
      this.schoolProgramCategoryChanged.emit(null);
    }
  }

  onChange(item: any) {
    if (!item) {
      // @ts-ignore
      this.schoolProgramCategoryChanged.emit(null);
      return;
    }
    this.schoolProgramCategoryChanged.emit(item);
    this.onSaveLocalStorage();
  }

  getSchoolProgramCategories() {
    const data = {
      school_program_id: this.school_program_id,
    }
    this.categorySub?.unsubscribe();
    this.categorySub = this.schoolProgramService.getSchoolProgramCategory(data).subscribe((
        response: any) => {
      if(response['status']) {
        this.schoolProgramCategoryData = response['data'];
        if (this.schoolProgramCategoryData) {
          this.onCheckLocalStorage();
        }
      } else {

      }
    })
  }

  onCheckLocalStorage() {
    if (!this.localStorageName) {
      return;
    }
    if (!this.usingLocalStorage) {
      return;
    }

    this.loading = false;
    const val = JSON.parse(<string>this.setting.getConfig(this.localStorageName));
    if (val) {
      // @ts-ignore
      this.schoolprogramcategoryValue = this.schoolProgramCategoryData
        .find((i: SchoolProgramCategoryModel) => i.school_program_category_id === val.school_program_category_id);
      if (this.schoolprogramcategoryValue) {
        this.schoolProgramCategoryChanged.emit(this.schoolprogramcategoryValue);
      }
    }
  }

  onSaveLocalStorage() {
    if (!this.usingLocalStorage) {
      return;
    }
    this.setting.setConfig(this.localStorageName, JSON.stringify(this.schoolprogramcategoryValue));
  }
}
